import { z } from 'zod';

export const schema = z.array(
  z.object({
    id: z.string(),
    notifyViaEmail: z.boolean().optional(),
  }),
);

export const strictSchema = schema;

export type FormValues = z.infer<typeof schema>;
